




import { replaceExrtaSpaces } from '@/utils/commons'
import React from 'react';

export const ReviewMediaRow = ({ label, value }) => (
  <div className="review_grid_row grid grid-cols-2 gap-y-2 grid-col-rule">
    <div className="review_title">
      <span>{label}</span>
    </div>
    <div className="review_value text-white" data-testid="review-media-value">
      <span>{replaceExrtaSpaces(value ?? '')}</span>
    </div>
  </div>
);


export const ReviewRow = ({ label, value }) => (
  <div className="review_grid_row grid grid-cols-2 gap-y-2 grid-col-temp">
    <div className="review_title">
      <span>{label}</span>
    </div>
    <div className="review_value text-white" data-testid="review-value">
      <span>{replaceExrtaSpaces(value ?? '')}</span>
    </div>
  </div>
);
